import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeActor } from "../../store/sceneSlice";
import "../../css/CharacterTile.css";
import CharacterTile from "./CharacterTile";
import CharacterPlusTile from "./CharacterPlusTile";
import CharacterPickerModal from "./CharacterPickerModal";

export default function CharacterGallery({
  onPaintRequest,
  selectedActorId,
  setSelectedActorId,
  customSprites,
  onDeleteCustomSprite,
}) {
  const dispatch = useDispatch();
  const [pickerOpen, setPickerOpen] = useState(false);
  const { scenes, currentSceneIndex } = useSelector((s) => s.scene);

  const handleAdd = () => setPickerOpen(true);
  const handleClose = () => setPickerOpen(false);

  const actors = scenes[currentSceneIndex]?.actors || [];
  const canRemoveActor = actors.length > 1;

  const handleRemoveActor = (actorId) => {
    if (!canRemoveActor) return;
    dispatch(removeActor({ actorId }));
    if (actorId === selectedActorId) {
      const nextActor = actors.find((a) => a.id !== actorId);
      setSelectedActorId?.(nextActor?.id || null);
    }
  };

  return (
    <div className="character-gallery-panel">
      {actors.map((actor) => (
        <CharacterTile
          key={actor.id}
          name={actor.name}
          imageSrc={actor.image}
          selected={actor.id === selectedActorId}
          onClick={() => setSelectedActorId?.(actor.id)}
          onBrush={() => onPaintRequest?.()}
          onRemove={() => handleRemoveActor(actor.id)}
          canRemove={canRemoveActor}
        />
      ))}
      <CharacterPlusTile onClick={handleAdd} />

      {pickerOpen && (
        <CharacterPickerModal
          open={pickerOpen}
          onClose={handleClose}
          onPaint={() => {
            handleClose();
            onPaintRequest?.();
          }}
          customSprites={customSprites}
          onDeleteCustomSprite={onDeleteCustomSprite}
          setSelectedActorId={setSelectedActorId}
        />
      )}
    </div>
  );
}
